import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import AchievementsList from "./achievementsList";
import { paginatedAchievementList } from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../services/context";

function Achievement() {
  const { state } = useAppContext();
  const { permissions } = state;
  const navigate = useNavigate();
  const [achievements, setachievements] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const extracted = permissions?.filter(
      (perms) => perms.module === "Achievements"
    );
    if (extracted) {
      setGranted(extracted);
    }
  };

  const getData = async () => {
    const res = await paginatedAchievementList();
    if (res?.data?.success && res?.data?.data) {
      setachievements(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate);
    }
  };

  useEffect(() => {
    extractPermissions();
    getData();
  }, []);

  return (
    <DashboardLayout>
      <div>
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Management</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#8b8b8cbf" }}
                  >
                    Achievements
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <AchievementsList
          achievements={achievements}
          setachievements={setachievements}
          pagination={pagination}
          setPagination={setPagination}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
}

export default Achievement;
